/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';

import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { useProductFlow } from 'hooks/useProductFlow';
import { useTranslations } from 'hooks/useTranslations';

const DsTypography = dynamic(() => import('componentsV2/DS/Typography'), {
  ssr: false,
});

const PoliticsAndTerms = ({
  politicsUrl,
  termsUrl,
  termsLabel,
  showTerms = true,
}) => {
  const { currentStep } = useProductFlow();
  const { getPoliticsAndTermsText } = useTranslations();
  const t = useTranslations().tPoliticsAndTerms;

  const getTermsContent = () => {
    if (termsLabel) return termsLabel;

    if (currentStep?.props?.termsContent) {
      return currentStep.props.termsContent;
    }

    if (currentStep?.props?.useCheckboxContractTerms) {
      return getPoliticsAndTermsText('contractTerms');
    }

    return getPoliticsAndTermsText('termsOfUse');
  };

  const renderTerms = () => {
    const terms = getTermsContent();

    return (
      <>
        <DsTypography component="paragraph" size="small" color="neutral-high">
          {getPoliticsAndTermsText('agreeWithTermsText')}
        </DsTypography>

        <a
          id="live-open-terms"
          href={termsUrl}
          rel="noreferrer"
          target="_blank"
          style={{ textDecorationColor: 'var(--color-secondary-pure)' }}
        >
          <DsTypography
            component="paragraph"
            size="small"
            color="secondary-pure"
          >
            {terms}
          </DsTypography>
        </a>
      </>
    );
  };

  return (
    <div>
      {politicsUrl ? (
        <>
          <DsTypography component="paragraph" size="small" color="neutral-high">
            {t('agreeWithText')}
          </DsTypography>
          <a
            id="live-open-policy"
            href={politicsUrl}
            rel="noreferrer"
            target="_blank"
            style={{
              textDecorationColor: 'var(--color-secondary-pure)',
            }}
          >
            <DsTypography
              component="paragraph"
              size="small"
              color="secondary-pure"
            >
              {getPoliticsAndTermsText('privacyPolicy')}
            </DsTypography>
          </a>{' '}
          {!!termsUrl && showTerms && (
            <>
              <DsTypography
                component="paragraph"
                size="small"
                color="neutral-high"
              >
                {getPoliticsAndTermsText('andText')}{' '}
              </DsTypography>
              <a
                id="live-open-terms"
                href={termsUrl}
                rel="noreferrer"
                target="_blank"
                style={{ textDecorationColor: 'var(--color-secondary-pure)' }}
              >
                <DsTypography
                  component="paragraph"
                  size="small"
                  color="secondary-pure"
                >
                  {getTermsContent()}
                </DsTypography>
              </a>
            </>
          )}
        </>
      ) : (
        <p>{!!termsUrl && showTerms && renderTerms()}</p>
      )}
    </div>
  );
};

PoliticsAndTerms.defaultProps = {
  politicsUrl: '',
  termsUrl: '',
  termsLabel: undefined,
  product: '',
};

PoliticsAndTerms.propTypes = {
  politicsUrl: PropTypes.string,
  termsUrl: PropTypes.string,
  termsLabel: PropTypes.string,
  product: PropTypes.string,
};

export default PoliticsAndTerms;
